// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'
// -------------------------车型----------------------------
// 列表

// 车型列表查询接口
export function carModelList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/model/list',
    method: 'POST',
    data,
  })
}

/*  采销合同新增页——车辆ID模糊搜索接口 */
export function FuzzySearch(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/data',
    method: 'post',
    data,
  })
}


// ------------------------------出入库------------------------------------
// 获取最新的出入库信息
export function stockLogFindLastOne(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/findLastOne',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取车型
 * @apiUrl
 */
export function getCarModelList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/modelIdAndName',
    method: 'POST',
    data,
  })
}
/** -------------------*租赁方案管理*-----------------------* */

// 获取租赁方案列表 https://mock-test.cheweijia.com/project/10282/interface/api/485397
export function getLeasingSchemeConfigList(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/rent/plan/list',
    method: 'POST',
    data,
  })
}

/**
 * 获取租赁方案列表
 * @param {number} data.orderType 订单类型 1-个人订单
 * @param {number} data.rentCategory 租赁类别 1-租车 2-以租代购 4-司机合作
 * @param {number} data.state 方案状态 1-已上架 0-未上架
 * @param {number} data.modelId 车型id
 * @param {array} data.cityCodes 城市编码
 * @param {number} data.pageNum 当前页面
 * @param {number} data.pageSize 每页条数，创建订单时该值传99999，来获取全量数据
 * @returns
 */
export function getLeasingSchemeConfigListAll(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/listAll',
    method: 'POST',
    data,
  })
}

// 列表
export function getOutInList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/list',
    method: 'POST',
    data,
  })
}

// 更新租赁方案状态
export function updateLeasingSchemeConfig(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/updateState',
    method: 'POST',
    data,
    bizCode: [22051, 22052],
  })
}
// 事故
export function getLastOrder(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/getLastOrder',
    method: 'post',
    data,
  })
}

/**
 * @apiName 车辆详情
 * @apiUrl
 */
export function getCarDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/detail',
    method: 'POST',
    data,
  })
}

// 车辆提交审核结果
export function carSubmitAuditStatus(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carAuditRecord/update',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 各类型的车总数
 * @apiUrl
 */
export function getCarSummary(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/summary/getCarState',
    method: 'POST',
    data,
  })
}

// 车务状态的列表统计
export function getCarOperationState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/summary/getCarOperationState',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取城市列表
 * @apiUrl
 */
export function getCityList({
  plateNo, // 车牌号
  city, // 城市名
} = {}) {
  return request({
    url: '/admin/v1/vehicle/common/cityListV2',
    method: 'post',
    data: { plateNo, city },
  })
}


/**
 * @apiName 获取车源方(服务商列表查询接口)
 * @apiUrl
 */
export function getCarProvider(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}

/**
 * 新增-获取车源方、产权方下拉框使用（包含是否禁用）
 * enterPara：
 * * */
export function getCarProviderPropertyList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/listAll',
    method: 'POST',
    data,
  })
}

// 车辆标签查询
export function getCarLabelList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenantCustomTag/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName orc 获取驾驶证信息
 * @apiUrl
 */
export function getDrivingInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/vehicleLicense',
    method: 'POST',
    data,
  })
}

/**
 * @apiName orc 网约车证
 * @apiUrl
 */
export function getRideHailing(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/rideHailingTransportLicense',
    method: 'POST',
    data,
  })
}

/**
 * @apiName orc 网约车证
 * @apiUrl
 */
export function getNewwork(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/driverHailingLicense',
    method: 'POST',
    data,
  })
}

/**
 * @apiName orc 获取登记证信息
 * @apiUrl
 */
export function getRegistration(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/vehicleRegCert',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 新增车辆
 * @apiUrl
 */
export function addCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/add',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 修改车辆
 * @apiUrl
 */
export function editCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/update',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 退出运营/恢复运营状态
 * @apiUrl
 */
export function updateOperateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/updateState',
    method: 'POST',
    data,
  })
}

// 出入库详情
export function getOutInDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/details',
    method: 'POST',
    data,
  })
}

// 脱敏出入库详情
export function getOutInDetailsSensitive(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/details/sensitive',
    method: 'POST',
    data,
  })
}

// 获取出入库详情提交确认未捕获到的部分信息
export function getTempOutInDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/getStockInfo',
    method: 'POST',
    data,
  })
}


// 添加出入库记录
export function addOutIn(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/add',
    method: 'POST',
    data,
  })
}

// 新增出入库记录查询车辆 合同接口
export function getCarAndContractData(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/addCarAndContractData',
    method: 'POST',
    data,
  })
}

// 编辑出入库记录
export function editOutIn(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/update',
    method: 'POST',
    data,
  })
}

// 获取合同列表
export function getContractList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/list',
    method: 'POST',
    data,
  })
}

// 获取日志列表
export function getLogList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/system/operationLog/list',
    method: 'POST',
    data,
  })
}

// 采购订单列表
export function getPurchaseOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/purchase/order/list',
    method: 'POST',
    data,
  })
}

// 企业租赁订单列表
export function getLeaseOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/lease/order/list',
    method: 'POST',
    data,
  })
}

// 车辆采购信息列表
export function getCarPurchaseOrderInfoList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/purchase/order/info/list',
    method: 'POST',
    data,
  })
}

// 驾驶证OCR识别
export function ocrDriverLicense(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/driverLicense',
    method: 'POST',
    data,
  })
}

// 设为备车-取消备车
export function readyLease(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/readyLease',
    method: 'POST',
    data,
  })
}

// 查询待租标准
export function getCarRentStandardList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carRentStandard/list',
    method: 'POST',
    data,
  })
}
/** --------------------------*配置开关*---------------------------* */

// 编辑待租标准
export function setCarRentStandardEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carRentStandard/edit',
    method: 'POST',
    data,
  })
}

// 提交待审核
export function getcarAuditRecord(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carAuditRecord/submit',
    method: 'POST',
    data,
  })
}
// 提交审核结果
export function getcarResult(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carAuditRecord/update',
    method: 'POST',
    data,
  })
}

/// 提交并审核代码
export function updateAndSubmit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/updateAndSubmit',
    method: 'POST',
    data,
  })
}

// tab页数量统计
export function getStockLogSummary(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/summary',
    method: 'POST',
    data,
  })
}

// 获取产权方列表
export function propertyOwnerList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}

// 获取保险公司列表
export function getInsuranceCompanyList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}

// 获取保险公司列表-新（返回固定列表）
export function getInsuranceCompanyListV2(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/getInsuranceCompanyList',
    method: 'POST',
    data,
  })
}


// 查询车辆状态接口
export function getVehicleState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/state/getVehicleState',
    method: 'POST',
    data,
  })
}

// 根据车牌号查询车辆id
export function getCarInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/getCarInfo',
    method: 'POST',
    data,
  })
}

//  新增企业租赁订单
export function AddleaseOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/add',
    method: 'POST',
    data,
  })
}

// 企业订单新增租赁车辆
export function addleaseOrderCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/add/car',
    method: 'POST',
    data,
  })
}

// 个人租赁订单详情 + 相关事故、维保状态、违章状态 数量
export function orderDetailAndMore(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/modeConversion/detail',
    method: 'POST',
    data,
  })
}

// 审批任务详情
export function getApprovalTaskDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/getApprovalTaskDetail',
    method: 'POST',
    data,
  })
}

// --------------------------------证件------------------------
/* 证件状态统计 */
export function LicenseStateSummary() {
  return request({
    url: '/admin/v1/vehicle/carLicenseManage/summary',
    method: 'POST',
  })
}

/* 证件列表 */
export function licenseList(data) {
  return request({
    url: '/admin/v1/vehicle/carLicenseManage/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 编辑车辆不可租标签
 * @apiUrl
 */
export function editTag(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/editTag',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取待租标准数据
 * @apiUrl
 */
export function getCarStandardDataList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carRentStandard/listWithTag',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 编辑待租标准数据
 * @apiUrl
 */
export function editCarStandardDataList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carRentStandard/editWithTag',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 待处理车辆列表
 * @apiUrl
 */
export function pendingList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/management/pending/list',
    method: 'POST',
    data,
  })
}

// 退车交接时间确认调整
export function changeReturnCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/changeReturnCar',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 取消订单
 * @apiUrl
 */
export function cancelOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/cancel',
    method: 'POST',
    data,
  })
}

// ------------------------------------------车辆调拨-----------------------------------------------------
// 列表接口
export function vehicleTransferList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/transferTask/getPage',
    method: 'POST',
    data,
  })
}

// 创建任务接口
export function vehicleTransferCreate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/transferTask/create',
    method: 'POST',
    data,
  })
}

// 更新任务接口
export function vehicleTransferUpdate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/transferTask/recreate',
    method: 'POST',
    data,
  })
}

// 取消调拨任务接口
export function vehicleTransferClose(data = {}) {
  return request({
    url: '/admin/v1/vehicle/transferTask/cancel',
    method: 'POST',
    data,
  })
}

// 调拨任务详情接口
export function vehicleTransferDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/transferTask/getDetail',
    method: 'POST',
    data,
  })
}

// 查询调拨车辆列表
export function vehicleTransferCarsList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/transferTask/car/getPage',
    method: 'POST',
    data,
  })
}

// 查询可调拨车辆
export function vehicleTransferNotAllocated(data = {}) {
  return request({
    url: '/admin/v1/vehicle/transferTask/car/query',
    method: 'POST',
    data,
  })
}

// 批量同步导入车辆接口
export function vehicleTransferCarsBatchExport(data = {}) {
  return request({
    url: '/admin/v1/vehicle/transferTask/car/import',
    method: 'POST',
    data,
  })
}

// 取消调拨车辆（单条+多选）
export function vehicleTransferCarsBatchCancel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/transferTask/car/cancel',
    method: 'POST',
    data,
  })
}

// 查询tab对应的统计数据
export function vehicleTransferStatistics(data = {}) {
  return request({
    url: '/admin/v1/vehicle/transferTask/statistics',
    method: 'POST',
    data,
  })
}

// 采购 - 退车核算检验
export function returnCarCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/settlement/check',
    method: 'POST',
    data,
  })
}
// 车辆 - 证照管理导出
export function exportViolationManage(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carLicenseManage/export',
    method: 'post',
    data,
  })
}

/**
 * 证照管理 - 配置证照逾期提醒日期
 * https://mock-test.cheweijia.com/project/10282/interface/api/491439
 */
export function editRemindConfig(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carLicenseManage/remindConfig/edit',
    method: 'POST',
    data,
  })
}

/**
 * 证照管理 - 查看证照逾期提醒日期
 * https://mock-test.cheweijia.com/project/10282/interface/api/491437
 */
export function remindConfigDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carLicenseManage/remindConfig/detail',
    method: 'POST',
    data,
  })
}

/**
 * 公司-审批管理 我发起的审批 待我审批 刷新状态
 */
export function refreshApprovalStatus(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/refresh',
    method: 'POST',
    data,
  })
}

/**
 * 获取待处理车辆列表标签
 * @returns 待处理标签
 */
export function getWaitForHandleTags() {
  return request({
    url: '/admin/v1/vehicle/management/pending/statistics_v2',
    method: 'POST',
  })
}

/**
 * 车辆列表V2 https://mock-test.cheweijia.com/project/10282/interface/api/485559
 */
export function getCarListV2({
  pageNum,
  pageSize,
  deptIdList,
  id, // 车辆ID
  carModelId, // 车型id
  plateNo, // 根据车牌号拿到的车辆id
  carCreateStartDate, // 车辆创建时间开始
  carCreateEndDate, // 车辆创建时间结束
  tagId, // 车辆标签ID
  energyType,
  carState, // 车辆状态：5待入库/10待处理/15售后/20待租/40已租，注意: 查询全部状态时传空
  carMatterTabNo, // 车务状态：年审临过期 10/交强险临过期 20/商业险临过期 30/车证临过期  40/有违章 50/有事故 60/维修中 70/保养中 80，注意: 查询全部状态时传空
  inventoryState, // 库存状态 0出库 1在库
  providerId, // 车源方id
  purchaseType, // 采购类型 1自有车/2转租车
  purchaseState, // 采购状态 0未采购1采购待确认2采购中3未采购
  exitOperationState, // 退出运营状态 0未退出  1已退出/车辆库存列表只展示未退出运营的车辆，需要传0未退出/退出运营车辆列表只展示退出运营的车辆，需要传1已退出
  exitStartDate, // 运营退出时间左区间
  exitEndDate, // 运营退出时间有区间
  vin, // 车架号
  disposalMethod, // 处置方式: 1退回车源方/2个人购买/3公司回购/4保险赔付/5其他
  lockedState, // 订单锁定状态: 0未锁定/1已锁定
  engineNo, // 发动机号
  groupType, // 待租标准类型: 1车辆信息与证照状态 2自定义标签 3车务监控状态
  itemType, // 待租标准子类型，自定义标签为tagId，其他为待租标准子类型id
  transferState, // 调拨状态: 1待调拨、2待出库、3出库完成、4调拨取消、5待入库、6入库完成
  coolingMode, // 车辆电池冷却方式
  brandId, // 品牌ID
  seriesId, // 车系ID
  modelId, // 车型ID
  fuzzyExitReason, // 处置原因
  disposalMethodList, // 处置方式
  adcode, // 运营城市
}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/car/vehicle/list_v2',
    method: 'POST',
    data: {
      pageNum,
      pageSize,
      deptIdList,
      id,
      carModelId,
      plateNo,
      energyType,
      carCreateStartDate,
      carCreateEndDate,
      tagId,
      carState,
      carMatterTabNo,
      inventoryState,
      providerId,
      purchaseType,
      purchaseState,
      exitOperationState,
      exitStartDate,
      exitEndDate,
      vin,
      disposalMethod,
      lockedState,
      engineNo,
      groupType,
      itemType,
      transferState,
      coolingMode,
      brandId,
      seriesId,
      modelId,
      fuzzyExitReason,
      disposalMethodList,
      adcode,
    },
  })
}

// 根据车型&车牌号&VIN搜索车辆 https://mock-test.cheweijia.com/project/10282/interface/api/492321
export function searchCarsByPlateNoVin({
  pageNum,
  pageSize,
  fuzzyField, // 车牌号 or VIN
  modelId, // 车型
  state, // 状态
  deptId,
}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/car/vehicle/dataByPage',
    method: 'post',
    data: {
      pageNum,
      pageSize,
      fuzzyField,
      modelId,
      state,
      deptId,
    },
  })
}

